import { render, staticRenderFns } from "./userinfoAdd.vue?vue&type=template&id=026214b6&scoped=true"
import script from "./userinfoAdd.vue?vue&type=script&lang=js"
export * from "./userinfoAdd.vue?vue&type=script&lang=js"
import style0 from "./userinfoAdd.vue?vue&type=style&index=0&id=026214b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026214b6",
  null
  
)

export default component.exports